<template src="../templates/normal_fcont_134.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import CreativePrintInText from '../components/CreativePrintInText'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink';
import InfoMachineTranslation from '../components/InfoMachineTranslation'
import AppDownloadCreative from '../components/AppDownloadCreative'
import AppDownloadiPrint from '../components/AppDownloadiPrint'
import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,CreativePrintInText,
    InfoMachineTranslation,AppDownloadCreative,AppDownloadiPrint
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['134-1'],
      meta: [
        { name: 'description', content: this.$store.state.messages.messages['134-2']},
        { name: 'twitter:card', content: 'summary_large_image'},
        { property: 'og:title', content: this.$store.state.messages.messages['134-1']},
        { property: 'og:description', content: this.$store.state.messages.messages['134-2']},
        { property: 'og:image', content: 'https://support.epson.net/fun/assets/article134/images/i1_01.jpg'},
        { property: 'og:url', content: 'https://support.epson.net/fun/articles/134'}
      ]
    };
  }
  
};
</script>
<style >
</style>

